import React from 'react';
import { useSearchParams } from 'react-router-dom';
import useTranslation from '../../../../hooks/translation/useTranslation';
import InfoContentTab from './InfoContentTab';
import infoContentList from '../../../../../utils/constants/infoContentList';

const tabTitleClass = 'm-0 text-base leading-[26px]';
const buttonClass = 'border-0 bg-transparent cursor-pointer flex gap-[10px] items-center';

function InfoContentTabsList() {
  const { trans, configInfo } = useTranslation();
  const isGeorgian = configInfo?.countryCode === 'GE';

  const [, setSearchParams] = useSearchParams();
  const changeQuery = (value) => {
    setSearchParams({ tab: value });
  };

  return (isGeorgian ? infoContentList.ge : infoContentList.am).items.map(({
    key, label, tabLabel, labels, contentKey,
  }) => ({
    key,
    label: (
      <button
        className={buttonClass}
        onClick={() => changeQuery(key)}
        type="button"
      >
        <h3 className={tabTitleClass}>
          {labels ? labels.map((l, i) => (
            <React.Fragment key={l}>
              {i > 0 && '/'}
              {trans(l)}
            </React.Fragment>
          )) : trans(tabLabel || label)}
        </h3>
      </button>
    ),
    children: <InfoContentTab type={contentKey || key} />,
  }));
}

export default InfoContentTabsList;
